import React from "react";
import s from "./FancyTitle.module.css";

function alt(src) {
  const segments = src.split("/");

  return segments[segments.length - 1];
}

function FancyTitle({ title, icon, underline = "yes" }) {
  return (
    <div
      className={[
        s["fancy-title"],
        underline === "yes" ? s.underlined : "",
      ].join(" ")}
    >
      {icon && <img className={s.icon} src={icon} alt={alt(icon)} />}
      <h4>{title}</h4>
    </div>
  );
}

export default FancyTitle;
